module.exports = __webpack_public_path__ + "assets/5489956c6fbb4357d7dde19a096edfd9.png";